<div class="header navbar navbar-fixed-top">
    <div class="header-inner">
        <i class="fa fa-th switcher ml-3 u-cursor--pointer" (click)="goToDashboard()"></i>
        <span (click)="goToDashboard()" class="navbar-brand visible-lg-inline u-cursor--pointer"> PRO<span class="text-psd text-uppercase">SOCCER</span>DATA </span>

        <ul class="nav navbar-nav" *ngIf="currentUser">
            <li dropdown="" class="dropdown user ng-star-inserted">
                <a href="javascript:void(0)" data-toggle="dropdown" tabindex="-1" class="dropdown-toggle" style="height: 42px;" aria-haspopup="true"><div class="top-icon">
                        <span class="username">{{ currentUser.lastName }} {{ currentUser.firstName }}</span
                        ><i class="fa fa-angle-down"></i>
                    </div>
                </a>
                <ul class="dropdown-menu dropdown-menu-right">
                    <li>
                        <a (click)="logOut()"> <i class="fa fa-sign-out mr-2"></i>{{ 'central-login.log.out' | translate }} </a>
                    </li>
                </ul>
            </li>
        </ul>
    </div>
</div>
